import { fabric } from 'fabric';
import { ACTIVE_SELECTION, drawBorderOnOver, FABRIC_CUSTOM_OBJECT, GROUP, ungroup } from '../utils';
import { removeId, UpdateAllPathsAssociatedWithObj } from './fabric_flowchart';
import { updateLabel } from './label';

export const listIndex = {
  container: -1000,
  highlightPolyline: -4,
  highlightLabel: -4,
  polyline: -3,
  controlPoint: -2,
  label: -1,
  object: 0,
};

let listObj = [];
let position = { x: null, y: null };

function getCoords(object, isHasCoords = true) {
  let top, bot, left, right;
  if (!isHasCoords) {
    top = object.top;
    left = object.left;
    bot = object.top + object.getScaledHeight();
    right = object.left + object.getScaledWidth();
  } else {
    object.calcCoords();
    top = object.oCoords.tl.y;
    left = object.oCoords.tl.x;
    bot = object.oCoords.br.y;
    right = object.oCoords.br.x;
  }

  return {
    top,
    bot,
    left,
    right,
  };
}

export function getIndex(obj) {
  let index = window.canvas.getObjects()?.indexOf(obj);
  if (index >= 0) return index;
  index = window.canvas.getObjects()?.findIndex((o) => o.id && o.id === obj?.id);
  if (index >= 0) return index;
  return window.canvas.getObjects()?.length - 1;
}

export function setIndex(obj) {
  // move to the back, in front of the container
  if (!obj) return;
  const { canvas } = window;
  if (obj.container) canvas.sendToBack(obj);
  else {
    let index = 0;
    const len = canvas.getObjects().length;
    while (index < len) {
      if (canvas.item(index).isContainer) {
        index += 1;
      } else {
        canvas.moveTo(obj, index);
        if (obj.type === FABRIC_CUSTOM_OBJECT.polyline && !obj.isNotObj) {
          window.canvas.getObjects().map((e) => {
            if (e.isNotObj && e.type === FABRIC_CUSTOM_OBJECT.polyline) setIndex(e);
            return e;
          });
        }
        return;
      }
    }
  }
}

export function setStatusBeforeMovingObj(options) {
  while (listObj.length > 0) listObj.pop();
  const { target } = options;
  if (!target) return;
  // position = { ...window.canvas.getPointer() };
  position = { x: target.left, y: target.top };
  if (target.type === FABRIC_CUSTOM_OBJECT.polyline) {
    window.canvas.getObjects().map((e) => {
      if (e.polylineId === target.id) listObj.push(e);
      return e;
    });
  } else if (target.isContainer) {
    const container = getCoords(target);
    window.canvas.getObjects().map((e) => {
      const obj = getCoords(e);
      if (
        obj.top > container.top &&
        obj.left > container.left &&
        obj.bot < container.bot &&
        obj.right < container.right &&
        !e.polylineId &&
        e.name !== 'highlightPolyline'
      ) {
        listObj.push(e);
      }
      return e;
    });
  }
}

function movePolyline(polyline, delta) {
  let line = polyline;
  window.canvas.getObjects().forEach((e) => {
    if (polyline.id === e.id) line = e;
  });
  const index = getIndex(line);
  window.canvas.remove(line);
  const newpoints = [];
  line.points.map((e) => {
    newpoints.push({ x: e.x + delta.x, y: e.y + delta.y });
    return e;
  });

  const newline = new fabric.Polyline(newpoints, {
    padding: 20,
    name: line.name,
    fill: line.fill,
    stroke: line.stroke,
    strokeWidth: line.strokeWidth,
    opacity: line.opacity,
    toPort: line.toPort,
    fromPort: line.fromPort,
    toNode: line.toNode,
    fromNode: line.fromNode,
    toId: line.toId,
    fromId: line.fromId,
    hasControls: line.hasControls,
    hasBorders: line.hasBorders,
    lockMovementX: line.lockMovementX,
    lockMovementY: line.lockMovementY,
    perPixelTargetFind: true,
    destination: { x: line.destination.x + delta.x, y: line.destination.y + delta.y },
    isNotObj: line.isNotObj,
    isOverContainer: line.isOverContainer,
    originalName: line.originalName,
    id: line.id,
    objectCaching: false,
  });
  removeId(line.id);
  window.canvas.insertAt(newline, index);
  updateLabel(line);
  return newline;
}

export function containerMoving(options) {
  const { target } = options;
  if (target.isContainer) window.canvas.sendToBack(target);
  const tmpList = listObj;
  const newList = [];
  listObj = [];
  const pointer = { x: target.left, y: target.top };
  const delta = { x: pointer.x - position.x, y: pointer.y - position.y };
  position = { ...pointer };

  tmpList.map((e) => {
    if (e.isOverContainer === target.id) {
      if (e.type !== FABRIC_CUSTOM_OBJECT.polyline && e?.name !== FABRIC_CUSTOM_OBJECT.modifiableArrowLine) {
        e.set({
          left: e.left + delta.x,
          top: e.top + delta.y,
        });
        e.setCoords();
        newList.push(e);
      } else {
        const tmp = movePolyline(e, delta);
        if (tmp) newList.push(tmp);
        else newList.push(e);
      }
    }
    return e;
  });

  tmpList.map((e) => {
    const o = { target: e };
    if (e.isDiagram) UpdateAllPathsAssociatedWithObj(o);
    return e;
  });
  listObj = newList;
  if (target.isContainer) window.canvas.sendToBack(target);
}

export const getIntersectContainer = (obj) => {
  let data = false;
  window.canvas
    .getObjects()
    .filter((o) => o.isContainer)
    .map((o) => {
      if (obj.intersectsWithObject(o)) {
        data = o;
      }
    });
  return data;
};

export const isDragObjectHasContainer = (obj) => {
  return obj._objects?.some((o) => o.isContainer) && obj.type === ACTIVE_SELECTION;
};

export const isObjectWithinContainer = (ctr, obj) => {
  const isHasCoords = !!obj.oCoords;
  const container = getCoords(ctr, isHasCoords);
  const object = getCoords(obj, isHasCoords);

  if (
    object.top > container.top &&
    object.left > container.left &&
    object.bot < container.bot &&
    object.right < container.right
  ) {
    return true;
  }
  return false;
};

export const centerObjInContainer = (ctr, obj) => {
  const { canvas } = window;

  let dragObject = obj;
  if (dragObject.type === ACTIVE_SELECTION) {
    dragObject = dragObject.toGroup();
  }

  const dragObjectCenterPoint = dragObject.getCenterPoint();
  const containerCenterPoint = ctr.getCenterPoint();
  const diffX = containerCenterPoint.x - dragObjectCenterPoint.x;
  const diffY = containerCenterPoint.y - dragObjectCenterPoint.y;

  dragObject.set({
    left: dragObject.left + diffX,
    top: dragObject.top + diffY,
  });

  if (obj.type === ACTIVE_SELECTION) ungroup(dragObject, canvas, true);

  dragObject.setCoords();
};

export const resizeObjContainer = (object) => {
  const { canvas } = window;

  const container = canvas.getObjects().find((o) => o.id === canvas.drawOnOver);
  if (!container) return;

  let containerWidth = container.getScaledWidth();
  let containerHeight = container.getScaledHeight();

  const objScaledWidth = object.getScaledWidth();
  const objScaledHeight = object.getScaledHeight();
  const objWidth =
    Math.abs(objScaledWidth * Math.cos(object.angle)) + Math.abs(objScaledHeight * Math.sin(object.angle));
  const objHeight =
    Math.abs(objScaledHeight * Math.cos(object.angle)) + Math.abs(objScaledWidth * Math.sin(object.angle));

  switch (container.type) {
    case FABRIC_CUSTOM_OBJECT.swimLaneVertical:
      containerHeight -= container.headerStyle.height;
      break;
    case FABRIC_CUSTOM_OBJECT.swimLaneHorizontal:
      containerWidth -= container.headerStyle.width;
      break;
    default:
      break;
  }

  if (containerWidth < objWidth) {
    const width = containerWidth + objWidth;
    container.set({ width });
    if (container.type === FABRIC_CUSTOM_OBJECT.swimLaneVertical) {
      container.set({ headerStyle: { ...container.headerStyle, width } });
    }
  }

  if (containerHeight < objHeight) {
    const height = containerHeight + objHeight;
    container.set({ height });
    if (container.type === FABRIC_CUSTOM_OBJECT.swimLaneHorizontal) {
      container.set({ headerStyle: { ...container.headerStyle, height } });
    }
  }

  container.setCoords();

  const isWithin = isObjectWithinContainer(container, object);
  if (!isWithin) centerObjInContainer(container, object);

  canvas.requestRenderAll();
};

export const interactWithObjContainer = (obj) => {
  const { canvas } = window;
  const container = getIntersectContainer(obj);
  if (container) {
    canvas.drawOnOver = container.id;
    if (obj.type === ACTIVE_SELECTION) {
      obj
        .getObjects()
        .filter((o) => !o.isContainer)
        .map((o) => {
          o.set({ isOverContainer: container.id });
        });
    } else {
      obj.set({ isOverContainer: container.id });
    }
    const isHasContainer = isDragObjectHasContainer(obj);
    if (!isHasContainer) {
      drawBorderOnOver(canvas, container);
    }
  } else {
    canvas.drawOnOver = container;
    obj.set({ isOverContainer: container });
    drawBorderOnOver(canvas, container);
  }
};

export const dragOverObjContainer = (e) => {
  const { canvas, isDragContainer } = window;
  let target = canvas.findTarget(e);
  if (target) {
    if (target.isContainer && !isDragContainer) {
      canvas.drawOnOver = target.id;
    } else if (target.isOverContainer && !isDragContainer) {
      canvas.drawOnOver = target.isOverContainer;
      target = canvas.getObjects().find((o) => o.id === target.isOverContainer);
    }
  }
  drawBorderOnOver(canvas, target);
};

export const checkResizeObjContainer = () => {
  const { canvas } = window;
  const obj = canvas.getActiveObject();
  if (obj?.isContainer) {
    const objs = canvas.getObjects().filter((o) => o.isOverContainer === obj.id);
    objs.map((o) => {
      if (!obj.intersectsWithObject(o)) {
        o.set({ isOverContainer: false });
      }
    });
  }
};

export const dropOnObjContainer = (obj) => {
  const { canvas } = window;
  if (!obj || !canvas.drawOnOver) return;
  if (obj.type === ACTIVE_SELECTION || obj.type === GROUP) {
    obj
      .getObjects()
      .filter((o) => !o.isContainer)
      .map((o) => {
        o.set({ isOverContainer: canvas.drawOnOver });
      });
  }
  obj.set({ isOverContainer: canvas.drawOnOver });
  resizeObjContainer(obj);
  canvas.renderAll();
};

export const setOverContainerForSuggestShape = (obj) => {
  const container = getIntersectContainer(obj);
  if (container) {
    const isWithin = isObjectWithinContainer(container, obj);
    if (!isWithin) centerObjInContainer(container, obj);
    obj.set({ isOverContainer: container.id });
  }
};
